import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { DELETE_ROLE, EXPORT_ROLE } from './constants.js'
import { lang } from 'utils/helpers'
import { DotsOptionsSelector } from 'components/common'
import ModalDelete from 'components/ModalDelete'
import ModalAlert from 'components/ModalAlert'
import { getStaticImage } from 'utils/statics.js'

/**
 *
 * @param {string} typeOptions - Type of options to show = 'button' | 'dotsOptions' | 'iconButton
 * @param {string} className - Class name for the container
 * @param {string} classNameDots - Class name for the dots
 * @param {object} isOpen - Object with the state of the modal
 * @param {string} id - Id for the modal
 * @param {function} toggleDotsOptions - Function to toggle the modal
 * @param {array} options - List of options to show
 * @param {boolean} isOpenModalDelete - State of the modal delete
 * @param {boolean} isOpenModalExport - State of the modal export
 * @param {function} toggleDelete - Function to toggle the modal delete
 * @param {function} toggleExport - Function to toggle the modal export
 * @param {string} type - Type of the modal
 * @param {function} eventDelete - Function to execute when delete
 * @param {function} eventExport - Function to execute when export
 * @param {function} onClickButton - Function to execute when click the button
*/
const MenuDotsOptions = (props) => {
  const {
    typeOptions, className = '', classNameDots = 'newMenuHorizontal', isOpen, id, toggleDotsOptions,
    options=[], isOpenModalDelete, isOpenModalExport=false, toggleDelete, toggleExport=null, type,
    eventDelete, eventExport=null, onClickButton=null
  } = props

  const { role } = useSelector(state => state.user)
  const [optionsMenu, setOptionsMenu] = useState([])

  useEffect(() => {
    const getOptionsByRole = () =>{
      const optionsByRole = []
      for (const option of options) {
        switch (option.id) {
          case 'delete':
            if (DELETE_ROLE.includes(role))
              optionsByRole.push({ ...option, imageIcon: getStaticImage('/icons/orange-brand/icon-trash-bin-dark.svg') })
            break
          case 'export':
            if (EXPORT_ROLE.includes(role))
              optionsByRole.push({ ...option, imageIcon: getStaticImage('/icons/orange-brand/icon-export-dark.svg') })
            break
          case 'edit':
            optionsByRole.push({ ...option, imageIcon: getStaticImage('/icons/orange-brand/icon-pencil-square-dark.svg') })
            break
          case 'download':
            optionsByRole.push({ ...option, imageIcon: getStaticImage('/icons/orange-brand/icon-document-arrow-down-dark.svg') })
            break
          case 'downloadAll':
            optionsByRole.push({ ...option, imageIcon: getStaticImage('/icons/orange-brand/icon-multiple-document-arrow-down-dark.svg') })
            break
          case 'downloadAllZip':
            optionsByRole.push({ ...option, imageIcon: getStaticImage('/icons/orange-brand/icon-multiple-document-arrow-down-dark.svg') })
            break
          case 'resend':
            optionsByRole.push({ ...option, imageIcon: getStaticImage('/icons/orange-brand/icon-resend-dark.svg') })
            break
          case 'reply':
            optionsByRole.push({ ...option, imageIcon: getStaticImage('/icons/orange-brand/icon-reply-dark.svg') })
            break
          case 'replyAll':
            optionsByRole.push({ ...option, imageIcon: getStaticImage('/icons/orange-brand/icon-send-all-dark.svg') })
            break

          default:
            optionsByRole.push(option)
            break
        }
      }
      setOptionsMenu(optionsByRole)
    }
    getOptionsByRole()
  }, [])


  const getMenuByTypeOptions = () => {
    switch (typeOptions) {
      case 'dotsOptions':
      case 'dotsOptionsVertical' :
        if(optionsMenu.length){
          return (
            <div className={`containerDotsOptionsSelector ${className || ''}`}>
              <DotsOptionsSelector
                isOpen={isOpen[id]}
                toggle={toggleDotsOptions}
                options={optionsMenu}
                position='bottom'
                dotsPosition={typeOptions === 'dotsOptions' ? 'horizontal' : 'vertical'}
                className={classNameDots}
              />
            </div>
          )
        }
        return null
      case 'iconButton':
        if(DELETE_ROLE.includes(role))
          return (
            <button
              className='chat-composer__subjects-read-btn'
              type='button'
              onClick={onClickButton}
            >
              <figure>
                <img src={getStaticImage('/icons/orange-brand/icon-delete-small.svg')} alt='Delete' />
              </figure>
            </button>
          )
        return null
      case 'button':
        if(DELETE_ROLE.includes(role))
          return (
            <button
              className={`buttonRemove ${className || ''}`}
              type='button'
              onClick={onClickButton}
            >
              {lang('dashboard_delete')}
            </button>
          )
        return null
      default:
        break
    }
  }

  return (
    optionsMenu.length ? (
      <>
        {getMenuByTypeOptions()}
        <ModalDelete
          isOpen={isOpenModalDelete}
          toggle={toggleDelete}
          header={lang(`${type}_delete_modal_header`)}
          text1={lang(`${type}_delete_modal_text_1`)}
          text2={lang('dashboard_process-cannot-reversed')}
          event={eventDelete}
          isSubmitting={false}
        />
        <ModalAlert
          isOpen={isOpenModalExport}
          toggle={toggleExport}
          header={lang(`${type}_export_modal_header`)}
          text1={lang(`${type}_export_modal_text_1`)}
          text2={lang('dashboard_operation-may-take-several-minutes')}
          event={eventExport}
        />
      </>
    ) : null
  )
}

export default MenuDotsOptions